import { render, staticRenderFns } from "./DiligenceTabs.vue?vue&type=template&id=25cec1d6"
import script from "./DiligenceTabs.vue?vue&type=script&lang=js"
export * from "./DiligenceTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports